// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collection-headline[data-v-6ac759ee]{margin:56px 0;text-align:center}@media(min-width:768px){.collection-headline[data-v-6ac759ee]{margin:120px 0}}.collection-headline[data-v-6ac759ee] .collection-headline-part{display:inline-block}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
